import React from "react";

import { css } from "@emotion/react";
import cx from "classnames";

import { COLORS } from "styles-js";


const fieldStyle = css`
  clear: both;
  margin: 0 0 10px;
  flex-grow: 1;
  > label {
      flex: 1 1 100%;
      font-size: 16px;
      color: ${COLORS.charcoalGrey};
    }
  &.field-radio {
    > label {
      font-size: 11px;
      color: ${COLORS.coolGrey};
      line-height: 11px;
      margin-bottom: 6px;
      display: block;
    }
  }
`;

interface FormFieldProps {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export default function FormField({
  children,
  className,
  ...restProps
}: FormFieldProps) {

  return (
    <div
      className={cx("form-field", className)}
      css={fieldStyle}
      {...restProps}>
      {children}
    </div>
  );
}
